module.exports = __webpack_public_path__ + "img/bus-white-bg-red.49b897c1.svg";